const STORAGE_PREFIX = 'em3:mapViewport';
const ANONYMOUS_BUCKET = 'anonymous';

export interface SavedViewport {
  lng: number;
  lat: number;
  zoom: number;
}

export const viewportStorageKey = (userId: string | null | undefined): string =>
  `${STORAGE_PREFIX}:${userId || ANONYMOUS_BUCKET}`;

const isFiniteNumber = (n: unknown): n is number =>
  typeof n === 'number' && Number.isFinite(n);

const isValidViewport = (v: unknown): v is SavedViewport => {
  if (!v || typeof v !== 'object') return false;
  const { lng, lat, zoom } = v as Partial<SavedViewport>;
  if (!isFiniteNumber(lng) || !isFiniteNumber(lat) || !isFiniteNumber(zoom)) return false;
  if (lng < -180 || lng > 180) return false;
  if (lat < -90 || lat > 90) return false;
  if (zoom < 0 || zoom > 24) return false;
  return true;
};

export const loadSavedViewport = (userId: string | null | undefined): SavedViewport | null => {
  try {
    const raw = localStorage.getItem(viewportStorageKey(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return isValidViewport(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const saveViewport = (
  userId: string | null | undefined,
  viewport: SavedViewport
): void => {
  if (!isValidViewport(viewport)) return;
  try {
    localStorage.setItem(viewportStorageKey(userId), JSON.stringify(viewport));
  } catch {
    // localStorage may be unavailable (private mode, quota); silently skip
  }
};
